import Table from '@/components/Table'
import { TableData } from '@/components/Table/type'
import { useSupplierQuery } from '@/queries/useSupplierQuery'
import { Supplier } from '@/types/Supplier'
import { createColumnHelper } from '@tanstack/react-table'
import { useMemo } from 'react'
import DadosMestreHeader from '../components/DadosMestreHeader' 
import DadosMestreHeaderActions from '../components/DadosMestreHeaderActions' 
import DefaultColumn from '@/components/Table/components/DefaultColumn'
import { useTable } from '@/hooks/useTable'

export type SupplierTable = TableData<Supplier>

const columnHelper = createColumnHelper<Supplier>()

const MasterDataSupplier = () => {
    const {
        table,  
        selectedRows,  
        onClickMultiDelete, 
        setTable,
    } = useTable<Supplier>('')
  
    const { data, isFetching, isPending, refetch } = useSupplierQuery()
    
    const memoData = useMemo(() => data || [], [data])
    const memoColumns = useMemo(
        () => [
            columnHelper.accessor('NK_FORNECEDOR', {
                id: 'NK_FORNECEDOR',
                header: 'Cod. Fornecedor',
                size: 140,
            }),
            columnHelper.accessor('DD_LOJA', {
                id: 'DD_LOJA',
                header: 'Cod. Loja',
                size: 100
            }),
            columnHelper.accessor('NM_RAZAO_SOCIAL', {
                id: 'NM_RAZAO_SOCIAL',
                header: 'Razão Social',
                size: 360,
            }),
            columnHelper.accessor('NM_FANTASIA', {
                id: 'NM_FANTASIA',
                header: 'Nome Fantasia',
                size: 260,
            }),
            columnHelper.accessor('DD_CNPJ', {
                id: 'DD_CNPJ',
                header: 'CNPJ',
                size: 160,
            }),  
        ],
        []
    )

    return (
        <div className="w-full h-full p-4 overflow-hidden">
            <Table<SupplierTable>
                data={memoData}
                columns={memoColumns}
                getRowId={(row) => row.SK_FORNECEDOR.toString()}
                isLoading={isPending}
                isFetching={isFetching}
                getTableInstance={(table) => setTable(table)} 
                tableHeader={
                    <DadosMestreHeader
                        title={`Fornecedores`}
                        onDelete={onClickMultiDelete}
                        selectedRows={
                            table
                                ?.getFilteredRowModel()
                                .flatRows.filter((row) => selectedRows[row.id])
                                .length
                        }
                    />
                }
                tableActions={
                    <DadosMestreHeaderActions 
                        onRefech={refetch} 
                    />
                } 
                defaultColumn={{
                    cell: ({ getValue }) => (
                        <DefaultColumn>{getValue() as string}</DefaultColumn>
                    ),
                }}
            /> 
        </div>
    )
}

export default MasterDataSupplier
